/* eslint-disable react-hooks/exhaustive-deps */
import FileUpload from "components/FileUpload";
import ImageModal from "components/ImageModal";
import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import MainLayout from "layouts/MainLayout";
import SuspectDetailInfo from "pages/Incident/IncidentDetail/modals/SuspectDetailInfo";
import WitnessOnlyDetail from "pages/Incident/IncidentDetail/modals/WitnessOnlyDetail";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  fetchCrimeCategoryBaseData,
  fetchCrimeType,
  fetchProsecutorDecision,
} from "services/basedataServices";
import { addDefendantCase } from "services/caseServices";
import { fetchSuspect, fetchWitness } from "services/lealIntityService";
import {
  CaseCreation,
  CrimeCategoryBaseData,
  CrimeLevel,
  CrimeTypeBaseData,
  DefendantCaseDetail,
  ProsecutorDecisionBaseData,
  Roles,
  Suspect,
  Witness,
} from "types";
import { viewIcon } from "utils/constant";
import { errorHandlerOnForm, hasRole } from "utils/helper";

const defaultValue: DefendantCaseDetail = {
  id: 0,
  defendants: [],
  witness: [],
  upload_charge_draft_upload: null,
  prosecutor_registration_number: "",
  incident_registration_no: "",
  crime_refernce_number: "",
  crime_type: "",
  crime_level: null,
  articles_ofthe_charge: "",
  upload_charge_draft: null,
  uuid_dms_upload_charge_draft: "",
  prosecutor_decision: "",
  prosecutor_decision_description: "",
  status: "Pending",
};

const RequestInstituteOfCharge: React.FC = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const caseData: CaseCreation | null = state?.caseData || null;
  const { loginData } = useAuth();
  const { showTooltip } = useTooltip();
  const [tab, setTab] = useState("Suspect Information");
  // const [refeatch, setRefetch] = useState(false);

  const [suspects, setSuspects] = useState<Suspect[]>([]);
  const [witnesses, setWitnesses] = useState<Witness[]>([]);
  const [selectedDefendant, setSelectedDefendant] = useState<Suspect>();

  const [formState, setFormState] = useState<DefendantCaseDetail>(defaultValue);
  const [witnessIds, setWitnessIds] = useState<number[]>([]);

  const [selectedEntity, setSelectedEntity] = useState<Suspect | Witness>();
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState({
    suspect: false,
    witness: false,
  });

  const [baseData, setBaseData] = useState<{
    crimeType: CrimeTypeBaseData[];
    prosecutorDecision: ProsecutorDecisionBaseData[];
    crimeCategory: CrimeCategoryBaseData[];
  }>({
    crimeType: [],
    prosecutorDecision: [],
    crimeCategory: [],
  });

  useEffect(() => {
    fetchCrimeCategoryBaseData().then((data) =>
      setBaseData((prev) => ({
        ...prev,
        crimeCategory: data,
      })),
    );
    fetchCrimeType().then((data) =>
      setBaseData((prev) => ({ ...prev, crimeType: data })),
    );
    fetchProsecutorDecision().then((data) =>
      setBaseData((prev) => ({ ...prev, prosecutorDecision: data })),
    );
  }, []);

  useEffect(() => {
    if (caseData) {
      setFormState({
        ...formState,
        case: caseData?.id ?? undefined,
        crime_refernce_number: caseData?.crime_refernce_number || "",
        incident_registration_no: caseData?.incident_registration_no || "",
        prosecutor_registration_number:
          caseData?.prosecutor_registration_number || "",
      });
      fetchSuspect()
        .then((data) => {
          setSuspects(
            data?.filter(
              (s) =>
                s?.Incident_Registration_number ===
                caseData?.incident_registration_no,
            ),
          );
        })
        .catch(console.error);
      fetchWitness()
        .then((data) =>
          setWitnesses(
            data?.filter(
              (s) =>
                s?.Incident_Registration_number ===
                caseData?.incident_registration_no,
            ),
          ),
        )
        .catch(console.error);
    }
  }, [caseData]);

  useEffect(() => {
    if (loginData) {
      setFormState((prevState) => ({
        ...prevState,
        receiving_prosecutor: hasRole(loginData?.roles, [Roles.prosecutor])
          ? loginData?.user_id
          : null,
        receiving_police: hasRole(loginData?.roles, [Roles.member])
          ? loginData?.user_id
          : null,
      }));
    }
  }, [loginData]);

  const handleFile = (name: string, file: File | null) => {
    setFormState({ ...formState, [name]: file });
  };

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = (tab = "all") => {
    if (!selectedDefendant) return "Suspect is Required";
    else if (!formState.crime_refernce_number)
      return "Crime Reference Number is Required.";
    else if (!formState.incident_registration_no)
      return "Incident Registration Number is Required.";
    else if (!formState.prosecutor_registration_number)
      return "Prosecutor Registration Number is Required.";
    else if (!formState.upload_charge_draft) return "Charge Draft is Required.";

    return "";
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const error = validateForm();
    if (error) {
      showTooltip(error, "error");
      return;
    }
    const formData: DefendantCaseDetail = {
      ...formState,
      defendants: selectedDefendant ? [selectedDefendant?.uu_id] : [],
      witness: witnessIds,
      upload_charge_draft_upload: formState.upload_charge_draft,
    };
    addDefendantCase(formData)
      .then(() => {
        showTooltip("Successfully Submitted!", "success");
        // setRefetch(!refeatch);
        navigate(0);
      })
      .catch((err) => {
        showTooltip(errorHandlerOnForm(err?.response?.data), "error");
      });
  };

  const buildView = (data: Suspect | Witness, type: "suspect" | "witness") => {
    return (
      <div>
        <div className="flex flex-row mt-4 border border-[#D4D4D4] p-4 rounded-lg">
          <div className="flex flex-1 items-center gap-2">
            <img
              src={
                data?.picture_file || require("../../images/imageVector.png")
              }
              alt="User"
              className="w-10 h-10 rounded mr-2 cursor-pointer"
              onClick={() => {
                setIsImageModalOpen(true);
                setSelectedEntity(data);
              }}
            />
            <div>
              <p className="text-gray-800 font-semibold">{`${data?.first_name} ${data?.middle_name} ${data?.last_name}`}</p>
              <div className="flex flex-row gap-1 items-center">
                <p className="text-gray-500 text-sm">{data?.age}</p>
                <p>•</p>
                <p className="text-gray-500 text-sm">{data?.phone_number}</p>
                <p>•</p>
                <p className="text-gray-500 text-sm">{data?.nationality}</p>
              </div>
            </div>
          </div>
          <div className="flex items-center mt-4 gap-2">
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                setIsDetailModalOpen({
                  suspect: type === "suspect",
                  witness: type === "witness",
                });
                setSelectedEntity(data);
              }}
            >
              {viewIcon}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <MainLayout>
      <div className="incidentRegistration max-w-screen-lg">
        <div className="incident-title">
          <span className="text-2xl font-semibold text-gray-700">
            ⚖ Institute of Charge
          </span>
        </div>
        <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
          <form onSubmit={handleSubmit}>
            <div className="bg-white shadow-md rounded-lg p-6 mt-4 ">
              {/* Suspect Information */}
              <div>
                <div className="flex items-center mt-4 w-[678px]">
                  <p
                    className="text-[#9D0303] font-[Poppins] font-[600] text-lg cursor-pointer"
                    onClick={() => setTab("Suspect Information")}
                  >
                    Suspect Information
                  </p>
                  <hr className="flex-1 border-t border-[#E9E9E9] ml-4" />
                </div>
                <div
                  className={tab === "Suspect Information" ? "block" : "hidden"}
                >
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Select Suspect
                      </label>
                      <select
                        className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                        value={selectedDefendant?.uu_id}
                        onChange={(e) => {
                          setSelectedDefendant(
                            suspects.find(
                              (s) =>
                                s.uu_id?.toString() ===
                                e.target.value?.toString(),
                            ) || undefined,
                          );
                        }}
                      >
                        <option value={""}>Select Suspect</option>
                        {suspects.map((suspect, index) => (
                          <option key={index} value={suspect?.uu_id}>
                            {suspect?.first_name} {suspect?.middle_name}{" "}
                            {suspect?.last_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {selectedDefendant && buildView(selectedDefendant, "suspect")}

                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Crime Registration Number
                      </label>
                      <input
                        type="text"
                        placeholder="#123456"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="crime_refernce_number"
                        value={formState?.crime_refernce_number ?? ""}
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Incident Registration Number
                      </label>
                      <input
                        type="text"
                        placeholder="#123456"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="incident_registration_no"
                        value={formState?.incident_registration_no ?? ""}
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Prosecutor Registration Number
                      </label>
                      <input
                        type="text"
                        placeholder="#123456"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="prosecutor_registration_number"
                        value={formState?.prosecutor_registration_number ?? ""}
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Article of Charge
                      </label>
                      <input
                        type="text"
                        placeholder="Article of Charge"
                        className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                        name="articles_ofthe_charge"
                        value={formState?.articles_ofthe_charge ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Prosecutor Decision
                      </label>
                      <select
                        className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                        name="prosecutor_decision"
                        value={formState?.prosecutor_decision ?? ""}
                        onChange={handleChange}
                      >
                        <option value={""}>Select Prosecutor Decision</option>
                        {baseData?.prosecutorDecision.map((type, index) => (
                          <option key={index} value={type?.decision}>
                            {type?.decision}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Crime Level
                      </label>
                      <select
                        className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                        name="crime_level"
                        value={formState?.crime_level ?? ""}
                        onChange={handleChange}
                      >
                        <option value={""}>Select Crime Level</option>
                        {Object.entries(CrimeLevel).map(([key, value]) => (
                          <option key={key} value={key}>
                            {value}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Crime Type
                      </label>
                      <select
                        className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                        name="crime_type"
                        value={formState?.crime_type ?? ""}
                        onChange={handleChange}
                      >
                        <option value={""}>Select Crime Type</option>
                        {baseData?.crimeType.map((type, index) => (
                          <option key={index} value={type?.name}>
                            {type?.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="flex flex-col mt-4">
                      <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                        Crime Category
                      </label>
                      <select
                        className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                        name="crime_type_catagory"
                        value={formState?.crime_type_catagory ?? ""}
                        onChange={handleChange}
                      >
                        <option value={""}>Select Crime Category</option>
                        {baseData?.crimeCategory
                          ?.filter(
                            (cc) =>
                              cc?.crime_type ===
                              baseData?.crimeType?.find(
                                (ct) => ct?.name === formState?.crime_type,
                              )?.id,
                          )
                          .map((type, index) => (
                            <option key={index} value={type?.name}>
                              {type?.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="flex flex-col mt-4">
                    <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                      Prosecutor Decision Description
                    </label>
                    <textarea
                      placeholder="Enter Prosecutor Decision Description"
                      className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                      name="prosecutor_decision_description"
                      value={formState?.prosecutor_decision_description ?? ""}
                      onChange={handleChange}
                      rows={4}
                    />
                  </div>

                  <div className="flex flex-col mt-4">
                    <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                      Select Witness
                    </label>
                    <select
                      className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300 h-32"
                      name="witness_ids"
                      value={witnessIds.map(String)}
                      onChange={(e) => {
                        const options: any = Array.from(
                          e.target.selectedOptions,
                          (option) => option.value,
                        );
                        setWitnessIds(options);
                        setFormState((prev) => ({
                          ...prev,
                          suspects_ids: options,
                        }));
                      }}
                      multiple
                    >
                      {Array.isArray(witnesses) &&
                        witnesses.map((witness) => (
                          <option key={witness?.uu_id} value={witness?.uu_id}>
                            {witness.first_name} {witness?.middle_name}{" "}
                            {witness.last_name}
                          </option>
                        ))}
                    </select>
                  </div>

                  {witnessIds &&
                    witnessIds?.map((witness) => {
                      const witnessData = witnesses.find(
                        (w) => w.uu_id === witness,
                      );
                      return witnessData ? (
                        <div>{buildView(witnessData, "suspect")}</div>
                      ) : null;
                    })}

                  <div className="mt-4 flex flex-row gap">
                    <FileUpload
                      label="Charge Draft"
                      fileTypes="*"
                      required={true}
                      onChange={(file) =>
                        handleFile("upload_charge_draft", file)
                      }
                    />
                    {/* <FileUpload
                      label="Charge Draft"
                      fileTypes="*"
                      required={true}
                      onChange={(file) =>
                        handleFile("upload_charge_draft_upload", file)
                      }
                    /> */}
                  </div>

                  {/* {buildView()} */}
                </div>
              </div>
            </div>

            <div className="flex flex-row mt-4 gap-3">
              {!caseData && (
                <input
                  type="reset"
                  className="border border-[#212121] px-[76px] py-3 text-[#747474] font-[Poppins] cursor-pointer font-[500] text-base rounded-md hover:bg-[#D4D4D4]"
                  value={"Cancel"}
                />
              )}
              <input
                type="submit"
                className="border border-[#212121] bg-[#212121] px-[76px] py-3 text-white font-[Poppins] cursor-pointer font-[500] text-base rounded-md hover:bg-[#414040]"
                value={caseData ? "Save" : "Finish"}
              />
            </div>
          </form>
        </div>
      </div>
      {isImageModalOpen && (
        <ImageModal
          isOpen={isImageModalOpen}
          imageSrc={
            selectedEntity?.picture_file ||
            require("../../images/imageVector.png")
          }
          label={
            selectedEntity?.first_name +
            " " +
            selectedEntity?.last_name +
            " " +
            selectedEntity?.last_name
          }
          onClose={() => setIsImageModalOpen(false)}
        />
      )}
      {isDetailModalOpen?.suspect && (
        <SuspectDetailInfo
          suspect={selectedEntity as Suspect}
          isOpen={isDetailModalOpen?.suspect}
          onClose={() =>
            setIsDetailModalOpen({
              suspect: false,
              witness: false,
            })
          }
        />
      )}
      {isDetailModalOpen?.witness && (
        <WitnessOnlyDetail
          witness={selectedEntity as Witness}
          isOpen={isDetailModalOpen?.witness}
          onClose={() =>
            setIsDetailModalOpen({ suspect: false, witness: false })
          }
        />
      )}
    </MainLayout>
  );
};

export default RequestInstituteOfCharge;
